"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var schema_1 = require("@cian/config/shared/schema");
var default_1 = require("@cian/config/shared/schema/default");
function createConfigSchema() {
    return schema_1.createSchema([
        default_1.createDefaultSchema(),
    ]);
}
exports.createConfigSchema = createConfigSchema;



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/authentication/schema.ts
// module id = 236
// module chunks = 2